  <app-navbar >
    <div class="container-fluid custom-bg">
      <div class="row m-0 p-1">
        <div class="p-1">
          <ul class="nav nav-custom mb-3" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="showOrdinaria"
                id="garantiaOrdinaria"
                (click)="showOrdinaria = true"
                role="button"
              >
                Garantia Ordinária
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="!showOrdinaria"
                id="garantiaEspecial"
                (click)="showOrdinaria = false"
                role="button"
              >
                Garantia Especial [DPGE]
              </a>
            </li>
          </ul>
        </div>

        <div class="container-page">
          <div class="left-content">
            <div class="p-1">
              <div class="p-1">
                <div class="tab-content" *ngIf="showOrdinaria" id="garantiaOrdinaria">
                  <div class="row p-1">
                    <h3 class="title-page mt-2">Garantia Ordinária</h3>
                  </div>
                  <div class="row p-1">
                    <h3 class="small-title">Como funciona a garantia ordinária do FGC</h3>
                  </div>
                  <div class="row p-1">
                    <p class="info-text mt-2">
                      O FGC garante até R$250 mil por depositante/investidor (CPF ou CNPJ) instituição financeira associada ou conglomerado financeiro,
                      considerando os seguintes produtos:
                    </p>
                    <ul class="info-text">
                      <li>Conta corrente e depósitos em poupança;</li>
                      <li>CDB e RDB - Depósitos a prazo;</li>
                      <li>LCI - Letras de Crédito Imobiliário, LCD - Letras de Crédito do Desenvolvimento e LCA - Letras de Crédito do Agronegócio;</li>
                      <li>LH - Letras Hipotecárias e LC - Letras de Câmbio;</li>
                    </ul>
                    <h3 class="small-title mt-4">
                      Como funciona o processo de pagamento
                    </h3>
                    <div class="timeline-wrapper">
                      <div class="timeline-item">
                        <div class="timeline-marker">1</div>
                        <div class="timeline-content">
                          <h3 class="timeline-title">Banco Central decreta a liquidação</h3>
                          <p class="timeline-text">
                            A Instituição em liquidação prepara e envia ao FGC a lista de pessoas e valores a serem pagos.
                            O liquidante leva, em média, 30 dias para completar esta etapa do processo.
                          </p>
                        </div>
                      </div>

                      <div class="timeline-item">
                        <div class="timeline-marker">2</div>
                        <div class="timeline-content">
                          <h3 class="timeline-title">Pedido de garantia</h3>
                          <p class="timeline-text">
                            Com as informações recebidas da Instituição, o FGC libera a solicitação da garantia para que
                            os credores completem sua identificação e cadastrem a conta bancária.
                          </p>
                        </div>
                      </div>

                      <div class="timeline-item">
                        <div class="timeline-marker">3</div>
                        <div class="timeline-content">
                          <h3 class="timeline-title">Pagamento de garantia</h3>
                          <p class="timeline-text">
                            Após a assinatura do termo de sub-rogação, o pagamento é realizado na conta bancária de
                            titularidade do credor que foi cadastrada.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-content" *ngIf="!(showOrdinaria)" id="garantiaEspecial">
                  <div class="row p-1">
                    <h3 class="title-page mt-2">Garantia Especial (DPGE)</h3>
                  </div>
                  <div class="row p-1">
                    <h3 class="small-title">Sobre a Garantia</h3>
                  </div>
                  <div class="row p-1">
                    <p class="info-text mt-4">
                      O DPGE é um depósito a prazo que conta com uma garantia especial
                      prestada pelo Fundo Garantidor de Créditos (FGC), conforme os critérios estabelecidos na regulamentação vigente.
                    </p>
                    <p class="info-text">
                      A cobertura do FGC ao DPGE deverá ser paga em até 3 (três) dias úteis
                      após a decretação da intervenção ou da liquidação extrajudicial. O prazo
                      será estendido, na hipótese de divergência ou atraso na entrega de informações e documentos,
                      até que os procedimentos publicados pelo FGC sejam atendidos.
                    </p>
                    <p class="info-text">
                      Após a validação de poderes de representação, o termo de sub-rogação e a carta para transferência do ativo na registradora (B3)
                      serão assinados e o pagamento realizado na conta de titularidade do credor.
                    </p>
                    <p class="info-text">Para mais informações sobre o pagamento de DPGE, acesse a FAQ do nosso site (<a href="https://www.fgc.org.br/faq" target="_blank">link</a>) </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="right-content">
            <div class="container-fluid p-sm-5">
              <div class="header-section mb-4">
                <h2 class="title-page-regime">Instituições em Regime Especial</h2>
                <p class="small-title-regime">Lista informativa das instituições financeiras em liquidação.</p>
              </div>

              <div class="row card-carousel-container justify-content-center">
                <div *ngFor="let card of tableDataCard | paginate: {itemsPerPage: 6, currentPage: p}"
                    class="col-12 col-md-6 col-xl-4 mb-4 d-flex justify-content-center">

                  <div class="card card-regime-especial">
                    <div class="card-body">
                      <div class="icon-container mb-4">
                        <span class="material-icons-outlined">
                          account_balance
                        </span>
                      </div>
                      <h3 class="card-title">{{card.nomeInstituicaoFinanceira}}</h3>
                      <div class="mt-auto w-100">
                        <span class="badge-liquidacao w-100">
                          Liquidação: {{card.dataLiquidacao | date: 'dd/MM/yyyy'}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="tableDataCard.length == 0" class="text-center my-5">
                <div class="card card-regime-especial p-4">
                  <p class="mb-0 card-title">Nenhuma instituição financeira encontrada em regime especial.</p>
                </div>
              </div>
                <pagination-controls
                    *ngIf="tableDataCard.length >= 2"
                    (pageChange)="p = $event"
                    responsive="true"
                    previousLabel=""
                    nextLabel="">
                </pagination-controls>

              <div class="view-ifs d-flex justify-content-center">
                <a routerLink="/instituicoes" class="view-all-link">
                  Ver todas as instituições <i class="fas fa-arrow-right"></i>
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-navbar>
  <app-footer></app-footer>
